/**
 * Modal Trigger Script
 * Automatically converts anchor links to modal triggers and sets up event listeners
 */

document.addEventListener('DOMContentLoaded', function() {
  initModalTriggers();
  setupKeyboardSupport();
});

// Listen for product-flavor:refreshed event to re-initialize modal triggers
document.addEventListener('variant:update-media', function() {
  console.log('re-init modal triggers')
  setTimeout(function() { initModalTriggers() },1000);
});

/**
 * Initialize modal triggers for all modal sections
 */
function initModalTriggers() {
  // First, find all modal sections by data-modal-id
  const modalSections = document.querySelectorAll('[data-modal-id]');
  
  modalSections.forEach(function(modalSection) {
    const modalId = modalSection.getAttribute('data-modal-id');
    
    if (modalId) {
      // Find all anchor tags that link to this modal ID
      const modalLinks = document.querySelectorAll(`[href="#${modalId}"]`);
      console.log('modalLinks', modalLinks)
      
      // Convert each matching link to a modal trigger button
      modalLinks.forEach(function(link) {
        convertLinkToModalTrigger(link, modalId);
      });
      
      // Set up close button functionality for this modal
      setupModalCloseButton(modalSection, modalId);
    }
  });
}

/**
 * Converts an anchor link to a modal trigger button
 * @param {HTMLElement} link - The anchor element to convert
 * @param {string} modalId - The ID of the modal to trigger
 */
function convertLinkToModalTrigger(link, modalId) {
  // Create a new button element
  const button = document.createElement('button');
  
  // Copy all attributes from the link to the button
  Array.from(link.attributes).forEach(attr => {
    button.setAttribute(attr.name, attr.value);
  });
  
  // Copy the inner HTML/content from the link to the button
  button.innerHTML = link.innerHTML;
  
  // Add modal-specific classes and attributes
  button.classList.add('modal-trigger');
  button.setAttribute('data-modal-target', modalId);
  button.setAttribute('type', 'button');
  
  // Add click event listener
  button.addEventListener('click', function(e) {
    e.preventDefault();
    openModal(modalId);
  });
  
  // Replace the link with the button
  link.parentNode.replaceChild(button, link);
}

/**
 * Sets up close button functionality for a modal
 * @param {HTMLElement} modalSection - The modal section element
 * @param {string} modalId - The ID of the modal
 */
function setupModalCloseButton(modalSection, modalId) {
  // Find close buttons within the modal
  const closeButtons = modalSection.querySelectorAll('[data-modal-close], .modal-close, .close-modal, button[aria-label*="close"], button[aria-label*="Close"]');
  
  closeButtons.forEach(function(closeButton) {
    // Add click event listener to close the modal
    closeButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeModal(modalId);
    });
    
    // Add modal-close class for styling
    closeButton.classList.add('modal-close');
  });
  
  // Also handle clicking outside the modal to close (optional)
  modalSection.addEventListener('click', function(e) {
    // If clicking on the modal backdrop (the modal section itself)
    if (e.target === modalSection) {
      closeModal(modalId);
    }
  });
}

/**
 * Opens a modal by setting the appropriate data attributes
 * @param {string} modalId - The ID of the modal to open
 */
function openModal(modalId) {
  // Set body attribute to indicate modal is open
  document.body.setAttribute('data-modal-open', 'true');
  
  // Find the modal element and set its open attribute
  const modalElement = document.querySelector(`[data-modal-id="${modalId}"]`);
  if (modalElement) {
    modalElement.setAttribute('data-modal-open', 'true');
    
    // Dispatch a custom event for other scripts to listen to
    const event = new CustomEvent('modalOpened', {
      detail: {
        modalId: modalId,
        modalElement: modalElement
      }
    });
    document.dispatchEvent(event);
  }
}

/**
 * Closes a modal by removing the data attributes
 * @param {string} modalId - The ID of the modal to close (optional, closes all if not specified)
 */
function closeModal(modalId = null) {
  if (modalId) {
    // Close specific modal
    const modalElement = document.querySelector(`[data-modal-id="${modalId}"]`);
    if (modalElement) {
      modalElement.removeAttribute('data-modal-open');
    }
  } else {
    // Close all modals
    const openModals = document.querySelectorAll('[data-modal-open="true"]');
    openModals.forEach(modal => {
      modal.removeAttribute('data-modal-open');
    });
  }
  
  // Remove body attribute
  document.body.removeAttribute('data-modal-open');
  
  // Dispatch a custom event for other scripts to listen to
  const event = new CustomEvent('modalClosed', {
    detail: {
      modalId: modalId
    }
  });
  document.dispatchEvent(event);
}

  // Make functions globally available
  window.openModal = openModal;
  window.closeModal = closeModal;

/**
 * Sets up keyboard support for closing modals with ESC key
 */
function setupKeyboardSupport() {
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      // Check if any modal is currently open
      const openModal = document.querySelector('[data-modal-open="true"]');
      if (openModal) {
        const modalId = openModal.getAttribute('data-modal-id');
        if (modalId) {
          closeModal(modalId);
        }
      }
    }
  });
}

 